import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-[#0d0b18] border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">SolveICSE</h3>
            <p className="text-gray-400 text-sm">
              Empowering ICSE & ISC students with free educational resources, past papers, and solutions.
            </p>
            <div className="flex items-center gap-2 text-purple-400 text-sm">
              <span>🎓</span>
              <span>Founded May 26, 2026</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/past-papers" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Past Papers
                </Link>
              </li>
              <li>
                <Link to="/textbook-answers" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Textbook Solutions
                </Link>
              </li>
              <li>
                <Link to="/community-chat" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Community Chat
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">
                  Recommended Books
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © 2026 SolveICSE. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="mailto:devajithmohanmohan@gmail.com"
                className="text-gray-400 hover:text-purple-400 transition-colors text-sm"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
